import http from './http';

export default {
  updateProfile(payload) { return http.put('/users/me', payload).then((r) => r.data.data); },
  changePassword(payload) { return http.put('/users/me/password', payload).then((r) => r.data.data); },
  uploadAvatar(file) {
    const form = new FormData();
    form.append('avatar', file);
    return http.post('/users/me/avatar', form, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data.data);
  },
  getPublicProfile(id) { return http.get(`/users/${id}`).then((r) => r.data.data); },
  getReputation(id) { return http.get(`/users/${id}/reputation`).then((r) => r.data.data); },
  requestVerification() { return http.post('/users/me/verification-request').then((r) => r.data.data.user); },
  block(id) { return http.post(`/users/${id}/block`).then((r) => r.data.data.blockedUsers); },
  unblock(id) { return http.delete(`/users/${id}/block`).then((r) => r.data.data.blockedUsers); },
  listBlocked() { return http.get('/users/blocked').then((r) => r.data.data.blockedUsers); },
};
